<template>
	<div>
		
		<div class="commonBox">
			<div>
				<div id="portfolioList" v-if="listShow">
					<ul>
						<li v-for="row in listData">
							<router-link :to="/portfolio/ + row.no">
								<p class="img">
									<img :src="row.thumbnail">
								</p>
								<p class="title"><span>{{ row.title }}</span></p>
								<p class="sub">{{ row.date }} | {{ row.client }}</p>
							</router-link>
						</li>
					</ul>
				</div>

			</div>
		</div>
		
		<router-view id="portfolioView"></router-view>
		
	</div>
</template>

<style>
	#portfolioList { padding-bottom: 0; }
	#portfolioList > ul { width: 100%; float: left; }
	#portfolioList > ul > li { width: calc(calc(100% - 20px) / 2); float: left; cursor: pointer; margin-right: 20px; margin-bottom: 20px; }
	#portfolioList > ul > li:nth-of-type(2n) { margin-right: 0; }
	#portfolioList > ul > li > a { width: 100%; float: left; }
	#portfolioList > ul > li > a > p { width: 100%; float: left; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
	#portfolioList > ul > li > a > p.img { padding-bottom: 58%; margin-bottom: 10px; }
	#portfolioList > ul > li > a > p.img > img { position: absolute; width: 100%; height: 100%; left: 0; top: 0; transition: all 0.5s; max-width: none; }
	#portfolioList > ul > li > a > p.title { font-size: 16px; color: #000; font-weight: 500; }
	#portfolioList > ul > li > a > p.sub { font-size: 12px; color: #666; margin-top: 2px; }
	
	@media (hover : hover){
		#portfolioList > ul > li > a:hover > p.img > img { width: 110%; height: 110%; left: -5%; top: -5%; }
		#portfolioList > ul > li > a:hover > p.title > span { text-decoration: underline; }
	}
	
	@media (max-width: 700px){
		#portfolioList > ul > li { width: 100%; margin-right: 0; }
	}
</style>

<script>
	var $;
	
	export default {
		name : "portfolio",
		data : function(){
			return {
				listShow : true,
				listData : [],
				topVisualTitle : "포트폴리오",
				topVisualSub : "일삼사삼사공에서 개발해드린 꿈들 목록입니다."
			}
		},
		watch: {
			$route(to, from){
				$.listShow = true;
				
				$.listData = [];
				if($.$route.path == "/portfolio"){
					$.$axios.get("//api.134340.kr/portfolio/list", { headers: $.$axiosHeader }).then(function(res){
						$.listData = res.data.data;

						$.$parent.pageOpen();
						$.$parent.topVisualTitle = $.topVisualTitle;
						$.$parent.topVisualSub = $.topVisualSub;
					});
				}
			}
		},
		methods : {
			pageLoad : function(){
				$ = this;
				
				$.listData = [];
				if($.$route.path == "/portfolio"){
					$.$axios.get("//api.134340.kr/portfolio/list", { headers: $.$axiosHeader }).then(function(res){
						$.listData = res.data.data;

						$.$parent.pageOpen();
						$.$parent.topVisualTitle = $.topVisualTitle;
						$.$parent.topVisualSub = $.topVisualSub;
					});
				}
			}
		},
		mounted : function(){
		},
		beforeMount : function(){
			this.pageLoad();
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/portfolio.vue